import BRAND from '../brand';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "Do I need an appointment?",
    answer: `Walk-ins are always welcome, but booking online guarantees your chair with no wait. A small deposit holds your spot and comes off your total.`
  },
  {
    question: "Why is there a deposit to book?",
    answer: `The deposit holds your barber's time. It's applied to your service — you only lose it if you no-show. It keeps the schedule honest so your appointment starts on time.`
  },
  {
    question: "What if I need to cancel or reschedule?",
    answer: `Call us at ${BRAND.phone} at least 2 hours ahead and we'll move your deposit to a new time, no problem.`
  },
  {
    question: "Do you cut kids' hair?",
    answer: `Yes — kids 12 and under get their own service at a lower price, and we're patient with first haircuts.`
  },
  {
    question: "What forms of payment do you take?",
    answer: `Cash and all major cards. Online deposits are handled securely by card or PayPal.`
  },
  {
    question: "How do I get in touch?",
    answer: `Call or text ${BRAND.phone}, or use the booking form — we'll confirm your appointment the same day.`
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 bg-base-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-gray-600">
            Everything you need to know before you sit in the chair
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-semibold text-gray-900">
                  {faq.question}
                </span>
                <svg
                  className={`w-6 h-6 text-primary transition-transform ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-primary/10 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Still have questions?
          </h2>
          <p className="text-gray-700 mb-6">
            We're here to help! Contact us and we'll be happy to assist you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={BRAND.phoneHref}
              className="px-6 py-3 bg-primary text-white font-bold rounded-lg shadow-md hover:bg-primary-focus transition-colors"
            >
              Call {BRAND.phone}
            </a>
            <Link
              to="/contact"
              className="px-6 py-3 bg-white text-primary font-bold rounded-lg shadow-md hover:bg-gray-50 transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
